export const useAppStoreOpener = () => ({
  openAppStore() {
    const APPLE_STORE_URL = 'https://apps.apple.com/jp/app/spotgig/id1466176511'
    const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=jp.co.axis_motion.spotgig'
    const userAgent = navigator.userAgent || navigator.vendor

    if (/android/i.test(userAgent)) {
      window.location.href = GOOGLE_PLAY_URL
      return true
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      window.location.href = APPLE_STORE_URL
      return true
    }

    return false
  }
})
